<template>
    <div class="error-login">
        <img class="logo" :src="srcsd">
        <h5 v-html="$t('errorLogin_text1')"></h5>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

export default defineComponent({
    setup() {
        const route = useRoute();
        const i18n = useI18n();
        var lang = route.params.lang

        // 設定頁面的語系
        i18n.locale.value = lang;
        localStorage.setItem("lang", lang);
        return {
            srcsd : require('@/assets/img/hita_white.png')
        }
    }
})
</script>

<style scoped>
.error-login{
    display: flex;
    height: 95vh;
    width: 100%;
    max-width: 320px;
    text-align: center;
    margin: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.error-login h5{
    font-size: 16px;
}
.error-login .logo{
    max-width: 280px;
    max-height: 410px;
}
</style>
